import { AnalysisCuboid, CuboidClickMode } from '@/types';
import { StateMap } from '@/utils/stateMap';
import { Number3, TransformMode } from '@abyss/3d-viewer';
import { AssemblyPoiWithCheckMark } from '../../pointOfInterest/PointOfInterestTab/SelectedPoiContent/Forms/LinkedPoiEditor/types';
import { StyledCuboid } from '@/modules/cuboids/types';
import { atom } from 'jotai';

export const currentCuboid = atom<StyledCuboid<AnalysisCuboid> | undefined>(undefined);

export const editingCuboids = atom<StateMap<string, AnalysisCuboid>>(
  new StateMap<string, AnalysisCuboid>()
);

export const cuboids = atom<StateMap<string, AnalysisCuboid>>(
  new StateMap<string, AnalysisCuboid>()
);

export const referenceCuboid = atom<AnalysisCuboid | undefined>(undefined);

export const cuboidTransformMode = atom<TransformMode>(TransformMode.BoxResize);

export const cuboidClickMode = atom<CuboidClickMode>(CuboidClickMode.Default);

export const isCuboidEditorEnabled = atom<boolean>(false);

export const isCuboidFlowEnded = atom<boolean>(false);

export const isCuboidVisibilityBoxEnabled = atom<boolean>(true);

export const isAddingWorkscope = atom<boolean>(false);

export const isIsolatedWorkscope = atom<boolean>(false);

export const cuboidLinkedPois = atom<AssemblyPoiWithCheckMark[] | undefined>(undefined);

export const cuboidResizeStep = atom<Number3>([0.5, 0.5, 1]);
